import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IpResolverService {
  private apiUrl = environment.apiUrl;
  private urlGetIp = `${this.apiUrl}origination/ip/get-ip`;

  constructor(private http: HttpClient) {}

  public getIPAddress() {
    return this.http.get<any>(this.urlGetIp);
  }
}
